module.exports = __webpack_public_path__ + "img/analysis_menu_tooltip.d3b92cb7.svg";